// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs/style/index.less
// module id = 1010
// module chunks = 1